module.exports = __webpack_public_path__ + "img/pauli-x-root-dagger-29.6946df8d.svg";